export default "__VITE_ASSET__D3bRwUX5__"